import { render, staticRenderFns } from "./blogs.vue?vue&type=template&id=75d3024b&"
import script from "./blogs.vue?vue&type=script&lang=js&"
export * from "./blogs.vue?vue&type=script&lang=js&"
import style0 from "./blogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports